import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首頁', href: '/' },
  { label: '關於心旅商研', href: '/about' },
  { label: '服務項目', href: '/services' },
  { label: '作品案例', href: '/cases' },
  { label: '規劃流程', href: '/process' },
  { label: '常見問題', href: '/faq' },
  { label: '專欄文章', href: '/insights' },
  { label: '聯絡諮詢', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#111111]/95 backdrop-blur-md border-b border-white/10'
          : 'bg-[#111111]'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between h-[72px]">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/957c6dfa2b6d3bb06c259ccd030b0148.png"
            alt="心旅商研 Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`whitespace-nowrap text-[1.0625rem] font-medium transition-colors duration-200 cursor-pointer ${
                location.pathname === link.href
                  ? 'text-[#b8956a]'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="hidden lg:flex items-center gap-2 px-5 py-2.5 bg-[#b8956a] text-white text-[1rem] font-medium rounded-full whitespace-nowrap hover:bg-[#a07d58] transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-calendar-line text-sm"></i>
          預約諮詢
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="開啟選單"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-[#111111] border-t border-white/10 px-6 pb-6">
          <nav className="flex flex-col gap-4 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-[1.125rem] font-medium cursor-pointer ${
                  location.pathname === link.href ? 'text-[#b8956a]' : 'text-white/80'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#b8956a] text-white text-[1rem] font-medium rounded-full whitespace-nowrap cursor-pointer"
            >
              預約諮詢
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
